// import React from "react";
// import { RiGolfBallLine } from "react-icons/ri";
// import { MdEmail } from "react-icons/md";
// import { FaPhoneVolume } from "react-icons/fa6";
// import { IoIosTime } from "react-icons/io";
// import { IoLocation } from "react-icons/io5";

// const Contact = () => {
//   return (
//     <div className="bg-[#fffdf7] py-20 px-6 md:px-20">
//       <div className="grid md:grid-cols-2 gap-10">
//         {/* Left Column - Contact Info */}
//         <div>
//           <p className="text-sm font-semibold tracking-widest flex items-center gap-2 mb-4">
//             <span>
//               <RiGolfBallLine className="bg-yellow-100 rounded-[50px]" />
//             </span>{" "}
//             CONTACT US
//           </p>
//           <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
//             Your <span className="relative inline-block">golf</span> journey
//             starts <br /> right here
//           </h2>

//           <hr className="border-t border-gray-200 my-6" />

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 text-black/80 mt-6">
//             {/* Email */}
//             <div className="flex items-start gap-3">
//               <span className="text-xl">
//                 <MdEmail />
//               </span>
//               <div>
//                 <h4 className="font-semibold text-black">Email</h4>
//                 <p>rgcc66div@gmail.com</p>
//                 <p>support@rgcc.com</p>
//               </div>
//             </div>

//             {/* Contact Us */}
//             <div className="flex items-start gap-3">
//               <span className="text-xl">
//                 <FaPhoneVolume />
//               </span>
//               <div>
//                 <h4 className="font-semibold text-black">Contact Us</h4>
//                 <p>+880 1766693142</p>
//                 {/* <p>+88 017696 63142</p> */}
//               </div>
//             </div>

//             {/* Working Hours */}
//             <div className="flex items-start gap-3">
//               <span className="text-xl">
//                 <IoIosTime />
//               </span>
//               <div>
//                 <h4 className="font-semibold text-black">Working Hours</h4>
//                 <p>Mon - Sat : 7:00 AM to 5:00 PM</p>
//                 <p>Sunday : Close</p>
//               </div>
//             </div>

//             {/* Location */}
//             <div className="flex items-start gap-3">
//               <span className="text-xl">
//                 <IoLocation />
//               </span>
//               <div>
//                 <h4 className="font-semibold text-black">Location</h4>
//                 <p>Ghaghat, Rangpur (Near Ghaghat Bridge)</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Column - Form */}
//         <div className="bg-[#fcfaec] rounded-xl p-6 md:p-10">
//           <h3 className="text-3xl font-bold mb-6 text-black">
//             Get in touch with us !
//           </h3>
//           <form className="space-y-4">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <input
//                 type="text"
//                 placeholder="First Name"
//                 className="p-3 rounded bg-white w-full outline-none"
//               />
//               <input
//                 type="text"
//                 placeholder="Last Name"
//                 className="p-3 rounded bg-white w-full outline-none"
//               />
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <input
//                 type="text"
//                 placeholder="Phone Number"
//                 className="p-3 rounded bg-white w-full outline-none"
//               />
//               <input
//                 type="email"
//                 placeholder="Email"
//                 className="p-3 rounded bg-white w-full outline-none"
//               />
//             </div>
//             <textarea
//               rows="4"
//               placeholder="Write Message..."
//               className="p-3 rounded bg-white w-full outline-none"
//             ></textarea>
//             <button
//               type="submit"
//               className="bg-lime-400 hover:bg-black hover:text-white w-full uppercase py-3 rounded-full font-bold text-black transition"
//             >
//               Submit Message
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact;

import React, { useState } from "react";
import { RiGolfBallLine } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { FaPhoneVolume } from "react-icons/fa6";
import { IoIosTime } from "react-icons/io";
import { IoLocation } from "react-icons/io5";
import { toast } from "react-hot-toast";
import api from "../api/axiosInstance";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post("/contact/submit", formData);
      toast.success("Message sent successfully!");

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#fffdf7] py-20 px-6 md:px-20">
      <div className="grid md:grid-cols-2 gap-10">
        {/* Left Column - Contact Info */}
        <div>
          <p className="text-sm font-semibold tracking-widest flex items-center gap-2 mb-4">
            <span>
              <RiGolfBallLine className="bg-yellow-100 rounded-[50px]" />
            </span>{" "}
            CONTACT US
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
            Your <span className="relative inline-block">golf</span> journey
            starts <br /> right here
          </h2>

          <hr className="border-t border-gray-200 my-6" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 text-black/80 mt-6">
            {/* Email */}
            <div className="flex items-start gap-3">
              <span className="text-xl">
                <MdEmail />
              </span>
              <div>
                <h4 className="font-semibold text-black">Email</h4>
                <p>rgcc66div@gmail.com</p>
                <p>support@rgcc.com</p>
              </div>
            </div>

            {/* Contact Us */}
            <div className="flex items-start gap-3">
              <span className="text-xl">
                <FaPhoneVolume />
              </span>
              <div>
                <h4 className="font-semibold text-black">Contact Us</h4>
                <p>+880 1766693142</p>
              </div>
            </div>

            {/* Working Hours */}
            <div className="flex items-start gap-3">
              <span className="text-xl">
                <IoIosTime />
              </span>
              <div>
                <h4 className="font-semibold text-black">Working Hours</h4>
                <p>Mon - Sat : 7:00 AM to 5:00 PM</p>
                <p>Sunday : Close</p>
              </div>
            </div>

            {/* Location */}
            <div className="flex items-start gap-3">
              <span className="text-xl">
                <IoLocation />
              </span>
              <div>
                <h4 className="font-semibold text-black">Location</h4>
                <p>Ghaghat, Rangpur (Near Ghaghat Bridge)</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Form */}
        <div className="bg-[#fcfaec] rounded-xl p-6 md:p-10">
          <h3 className="text-3xl font-bold mb-6 text-black">
            Get in touch with us !
          </h3>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="p-3 rounded bg-white w-full outline-none"
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="p-3 rounded bg-white w-full outline-none"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
                className="p-3 rounded bg-white w-full outline-none"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="p-3 rounded bg-white w-full outline-none"
              />
            </div>
            <textarea
              name="message"
              rows="4"
              placeholder="Write Message..."
              value={formData.message}
              onChange={handleChange}
              required
              className="p-3 rounded bg-white w-full outline-none"
            ></textarea>
            <button
              type="submit"
              disabled={loading}
              className={`${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-lime-400 hover:bg-black hover:text-white"
              } w-full uppercase py-3 rounded-full font-bold text-black transition`}
            >
              {loading ? "Sending..." : "Submit Message"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
